import React from "react";
import KuikaLabel, { KuikaLabelColor } from "../../../../ui-kit/kuika-label/kuika-label";
import KuikaSvg from "../../../../ui-kit/kuika-svg/kuika-svg";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";
import { VariantGrid } from "../_layout/variant-grid";

const COLORS: KuikaLabelColor[] = ["blue", "yellow", "green", "purple", "orange", "pink"];

export const LabelStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Label"
      componentName="KuikaLabel"
      sourcePath="ui-kit/kuika-label"
      description="Static color-coded label. Lighter than a Badge — meant for inline metadata next to titles and rows."
    >
      <VariantGrid
        label="color"
        cols={COLORS}
        cellMinWidth={130}
        render={(color: string): React.ReactNode => <KuikaLabel color={color as KuikaLabelColor} content={color} />}
      />
      <SpecRow label="With icons" caption="leftIcon / rightIcon">
        <KuikaLabel
          color="green"
          content="online"
          leftIcon={<KuikaSvg name="circle" width={8} height={8} color="currentColor" />}
        />
        <KuikaLabel
          color="orange"
          content="warning"
          leftIcon={<KuikaSvg name="info-circle" width={12} height={12} color="currentColor" />}
        />
        <KuikaLabel
          color="purple"
          content="beta"
          rightIcon={<KuikaSvg name="star" width={10} height={10} color="currentColor" />}
        />
      </SpecRow>
      <SpecRow label="interactive" caption="static (default) vs a label a consumer wires a click onto">
        <KuikaLabel color="blue" content="static (default)" />
        <KuikaLabel color="blue" content="interactive" interactive />
      </SpecRow>
    </ShowcaseFrame>
  );
};
